import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { HEADER_NAVIGATION_MENU_CLASS_PREFIX, headerNavigationMenuRoot } from './constants';
import { useHeaderNavigationMenuClassName } from './utils';
import { HeaderNavigationMenuContentContainer, HeaderNavigationMenuRoot, HeaderNavigationMenuTitle, HeaderNavigationMenuTitleContainer, MenuExpansionIndicator, MenuExpansionIndicatorItem } from './style';
import { headerNavigationMenuTheme } from './theme';
import HeaderNavigationMenuContentContext from './HeaderNavigationMenuContent/HeaderNavigationMenuContentContext';
import { DHLogoImage } from './DHLogoImage';
import { useHeaderNavigationMenu } from './utils/useHeaderNavigationMenu';
import { useComponentTheme } from '../../../utils/hooks';
import { HeaderNavigationItem } from '../HeaderNavigationItem';
export var HeaderNavigationMenu = forwardRef(function HeaderNavigationMenu(_ref, ref) {
  var className = _ref.className,
      _ref$headerTitle = _ref.headerTitle,
      headerTitle = _ref$headerTitle === void 0 ? React.createElement(DHLogoImage, null) : _ref$headerTitle,
      headerContent = _ref.headerContent,
      tabIndex = _ref.tabIndex,
      restProps = _objectWithoutProperties(_ref, ["className", "headerTitle", "headerContent", "tabIndex"]);

  var theme = useComponentTheme(HEADER_NAVIGATION_MENU_CLASS_PREFIX, headerNavigationMenuTheme);
  var classOverride = useHeaderNavigationMenuClassName(HEADER_NAVIGATION_MENU_CLASS_PREFIX, className);

  var _useHeaderNavigationM = useHeaderNavigationMenu(restProps, ref),
      internalRef = _useHeaderNavigationM.internalRef,
      isExpanded = _useHeaderNavigationM.isExpanded,
      setIsExpanded = _useHeaderNavigationM.setIsExpanded;

  var contextValue = {
    isExpanded: isExpanded,
    setIsExpanded: setIsExpanded
  };
  return React.createElement(HeaderNavigationMenuContentContext.Provider, {
    value: contextValue
  }, React.createElement(HeaderNavigationItem, {
    theme: theme,
    className: classOverride.NavigationMenuItem,
    flexGrow: 1
  }, React.createElement(HeaderNavigationMenuRoot, Object.assign({
    "data-testid": headerNavigationMenuRoot
  }, restProps, {
    theme: theme,
    className: classOverride.NavigationMenu
  }), React.createElement(HeaderNavigationMenuTitleContainer, {
    ref: internalRef
  }, React.createElement(HeaderNavigationMenuTitle, {
    theme: theme,
    className: classOverride.NavigationMenuItem
  }, headerTitle), headerContent && React.createElement(MenuExpansionIndicatorItem, {
    theme: theme,
    className: classOverride.NavigationMenuItem
  }, React.createElement(MenuExpansionIndicator, {
    displaySeparator: false,
    isExpanded: isExpanded,
    theme: theme,
    className: classOverride.MenuExpansionIndicator,
    tabIndex: tabIndex
  }))), React.createElement(HeaderNavigationMenuContentContainer, {
    theme: theme,
    isExpanded: isExpanded,
    className: classOverride.NavigationMenuContentContainer
  }, isExpanded && headerContent))));
});
HeaderNavigationMenu.defaultProps = {
  tabIndex: 0,
  defaultExpanded: false
};